export default "__VITE_ASSET__d4570bb4__"